document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll(".comparison-bar__content-title");
  const items = document.querySelectorAll(".comparison-bar__item");
  const section = document.querySelector(".comparison-bar__contents");

  const isMobile = window.matchMedia("(max-width: 980px)").matches;

  const animateBars = (container) => {
    const bars = container.querySelectorAll(".comparison-bar__graph-bar-inner");

    bars.forEach(bar => {
      bar.style.height = "0%";
    });

    setTimeout(() => {
      bars.forEach(bar => {
        const height = bar.getAttribute("data-height");
        bar.style.height = height + "%";
      });
    }, 50);
  };

  if (!isMobile && section) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          items.forEach(item => animateBars(item));

          obs.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
  }

  if (isMobile) {
    if (items.length) {
      items[0].classList.add("active");
      animateBars(items[0]);
    }

    titles.forEach(title => {
      title.addEventListener("click", () => {
        const tab = title.getAttribute("data-tab");

        titles.forEach(t => t.classList.remove("active"));
        items.forEach(item => item.classList.remove("active"));

        title.classList.add("active");

        const target = document.querySelector(`.comparison-bar__item[data-tab="${tab}"]`);

        if (target) {
          target.classList.add("active");
          animateBars(target);
        }
      });
    });
  }
});